import { createRouter } from "@tanstack/react-router";
import { getAppRouterOptions } from "@/router-options";

export function createAppRouter() {
	return createRouter(getAppRouterOptions());
}

declare module "@tanstack/react-router" {
	interface Register {
		router: ReturnType<typeof createAppRouter>;
	}
}
